/**
 * When true, live reads and boot hydration MAY fall back to the in-memory
 * brainStore (fixtures) if the API is unreachable. This is a TEST / STANDALONE
 * affordance only — the served app is DB-authoritative and must surface an
 * honest reconnecting state instead of resurrecting fixtures (that silent
 * substitution is the whole bug this change removes). Defaults from the build
 * mode: `vite build` / `vite dev` → false; Vitest → true.
 */
let storeFallbackEnabled = import.meta.env.MODE === 'test';

export function isStoreFallbackEnabled(): boolean {
  return storeFallbackEnabled;
}

/** Test-only: force the gate on/off so both code paths can be exercised. */
export function __setStoreFallback(enabled: boolean): void {
  storeFallbackEnabled = enabled;
}
